
import { Component, Vue } from "vue-property-decorator";
import { ActionEnum } from "@/store/enum/authActionEnum";
import { ResourceEnum } from "@/store/enum/authResourceEnum";
import { PartnerModule } from "@/store/modules/partner";
import { UserModule } from "@/store/modules/user.store";

@Component({})
export default class PermissionMixin extends Vue {
  get ActionEnum() {
    return ActionEnum;
  }
  get ResourceEnum() {
    return ResourceEnum;
  }

  get permissionPartnerId() {
    return PartnerModule.partner.id;
  }

  get canCreateMessage() {
    return UserModule.abilities.can(ActionEnum.CREATE, ResourceEnum.MESSAGE, this.permissionPartnerId);
  }

  get canUpdateReport() {
    return UserModule.abilities.can(ActionEnum.UPDATE, ResourceEnum.REPORT, this.permissionPartnerId);
  }

  get canCreateSign() {
    return UserModule.abilities.can(ActionEnum.CREATE, ResourceEnum.SIGN, this.permissionPartnerId);
  }

  get canShareContent() {
    return UserModule.abilities.can(ActionEnum.CREATE, ResourceEnum.SHARED_CONTENT, this.permissionPartnerId);
  }

  get canReadTemplate() {
    return UserModule.abilities.can(ActionEnum.READ, ResourceEnum.TEMPLATE, this.permissionPartnerId);
  }

  get canEditTemplate() {
    return UserModule.abilities.can(ActionEnum.UPDATE, ResourceEnum.TEMPLATE, this.permissionPartnerId);
  }
}
